import { useSelector } from 'react-redux';
import { APP_LOGO, APP_LOGO_SUCCESS } from '@spotMobileConfig';

export const useLogo = ({ isSuccessScreen = false } = {}) => {
  const logo = useSelector(({ appConfig }) => appConfig?.logo);

  return logo || (isSuccessScreen ? APP_LOGO_SUCCESS : APP_LOGO);
};
